"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
/**
 * Styled Button component
 */
const Button = (_a) => {
    var { design, disabled, fullWidth = false, small = false } = _a, rest = __rest(_a, ["design", "disabled", "fullWidth", "small"]);
    const buttonProps = {
        design,
        disabled,
        fullWidth,
        small,
    };
    switch (design) {
        case 'primary':
            return react_1.default.createElement(styled_1.ButtonPrimary, Object.assign({}, buttonProps, rest));
        case 'secondary':
            return react_1.default.createElement(styled_1.ButtonSecondary, Object.assign({}, buttonProps, rest));
        case 'flat':
            return react_1.default.createElement(styled_1.ButtonFlat, Object.assign({}, buttonProps, rest));
        case 'clear':
            return react_1.default.createElement(styled_1.ButtonClear, Object.assign({}, buttonProps, rest));
        default:
            return react_1.default.createElement(styled_1.ButtonPrimary, Object.assign({}, buttonProps, rest));
    }
};
exports.default = Button;
//# sourceMappingURL=Button.js.map